<template>
    <section
        class="vue-styles grid"
        :class="{['grid-cols-3']: !facType?.fac_type && !inModal}"
    >
        <div 
            v-if="!facType?.fac_type"

            class="col-span-1 gap-x-2 gap-y-4 grow p-4 lg:pt-9 lg:pb-11 lg:px-8"
            :style="{backgroundColor: backgroundColour}"
        >
            <form-field 
                type="select"

                label="Find a..."
                label-class="font-bold text-primary-dark"

                :options="facTypes"

                v-model="facType"
            />
        </div>

        <fac-search-header
            v-else

            :key="`fac-type--${facType.fac_type}`"
            :fac-type="facType.fac_type" 
            :redirect="facType.redirect"

            :in-modal="inModal"
            :background-colour="backgroundColour"

            additional-column
        >

            <div class="flex flex-col justify-end filter">
                <form-field 
                    type="select"

                    label="FAC Type"
                    label-class="font-bold text-primary-dark"
                    wrapper-class="flex flex-col"

                    :options="facTypes"

                    v-model="facType"
                />
            </div>

        </fac-search-header>
    </section>
</template>

<script setup>
    import { ref, watch } from 'vue'
    import FormField from '@app/components/acc/form/FormField.vue'
    import store from './state/store'

    const props = defineProps({
        facTypes         : Array,
        backgroundColour : String,
        inModal          : Boolean,
    })

    const facType = ref(null)

    watch(
        facType, 
        (current, old) => {
            if(current?.fac_type !== old?.fac_type){
                store.reset()
            }
        },
        { deep: true })
</script>